import { useState } from "react";
import { Run } from "./Run";
import { createEntityStore } from "../../common/entityStore";
import { Grid } from "@mui/material";
import { propEnumField, propFileField } from "../../common/entityStoreForm";
import { propRequired, propValueValidator } from "../../common/entityStoreValidators";
import { withSameProp } from "../../common/utils";
import { CustomerNoteActionTypeId, CustomerNoteTypeId, useCustomerNoteActionTypes, useCustomerNoteTypes } from "../../common/enum";

export const CustomerNoteImportPage = withSameProp("fake", () => (props: { fake?: boolean }) => {
    const [useParamsStore] = useState(() => createEntityStore<RunParams>({
        data: { customerNoteTypeId: CustomerNoteTypeId.System, customerNoteActionTypeId: CustomerNoteActionTypeId.None },
        id: null,
        propValidators: [
            propRequired("file"),
            propValueValidator("isFileImported", p => p && "File is already imported."),
            propRequired("customerNoteTypeId"),
            propRequired("customerNoteActionTypeId"),
        ]
    }));
    const [isRunning, setIsRunning] = useState(false);
    function renderParams() {
        return <>
            <Grid item xs={12}>{propFileField(useParamsStore)("file", "File", { disabled: isRunning, onChange: () => useParamsStore.getState().setClientDataProp("isFileImported", undefined) })}</Grid>
            <Grid item xs={12}>{propEnumField(useParamsStore)("customerNoteTypeId", "Note type", useCustomerNoteTypes, { showInactive: true })}</Grid>
            <Grid item xs={12}>{propEnumField(useParamsStore)("customerNoteActionTypeId", "Note action", useCustomerNoteActionTypes, { showInactive: true })}</Grid>
        </>;
    }
    return <>
        <Run name="Customer note import" fake={props.fake} hub="customerNoteImport" onRunFinished={p => p && useParamsStore.getState().setClientDataProp("isFileImported", true)}
            useParamsStore={useParamsStore} renderParams={renderParams} setIsRunning={setIsRunning} />
    </>;
});

interface RunParams {
    file?: File;
    isFileImported?: boolean;
    customerNoteTypeId?: number;
    customerNoteActionTypeId?: CustomerNoteActionTypeId;
}
